import type { Expense } from "@/models/types";

export const expenses: Expense[] = [
  {
    id: "exp-001",
    date: "2026-08-27",
    description: "Supermercado La Comer",
    categoryId: "cat-alimentacion",
    amount: 850,
    paymentMethod: "efectivo",
    notes: "Compra semanal de despensa",
    receipt: {
      id: "rec-001",
      fileName: "ticket-supermercado.jpg",
      fileType: "image",
      fileSize: 184320,
      url: "https://readdy.ai/api/search-image?query=Closeup%20of%20a%20white%20paper%20grocery%20store%20receipt%20with%20printed%20itemized%20lines%20and%20total%20amount%2C%20resting%20on%20a%20clean%20wooden%20surface%2C%20realistic%20document%20photography%2C%20soft%20natural%20light%2C%20high%20detail&width=800&height=1000&seq=receipt-grocery&orientation=portrait",
      uploadedAt: "2026-08-27T18:30:00",
    },
    createdAt: "2026-08-27T18:32:00",
  },
  {
    id: "exp-002",
    date: "2026-08-27",
    description: "Uber al centro",
    categoryId: "cat-transporte",
    amount: 180,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-27T14:10:00",
  },
  {
    id: "exp-003",
    date: "2026-08-26",
    description: "Suscripción Netflix",
    categoryId: "cat-entretenimiento",
    amount: 249,
    paymentMethod: "tarjeta",
    notes: "Plan estándar",
    createdAt: "2026-08-26T09:00:00",
  },
  {
    id: "exp-004",
    date: "2026-08-25",
    description: "Restaurante La Parrilla",
    categoryId: "cat-alimentacion",
    amount: 520,
    paymentMethod: "tarjeta",
    receipt: {
      id: "rec-002",
      fileName: "recibo-restaurante.pdf",
      fileType: "pdf",
      fileSize: 245760,
      url: "https://readdy.ai/api/search-image?query=Closeup%20of%20a%20white%20paper%20restaurant%20bill%20receipt%20with%20printed%20list%20of%20food%20items%20and%20total%2C%20on%20a%20dark%20wooden%20table%2C%20realistic%20document%20photography%2C%20warm%20ambient%20light%2C%20high%20detail&width=800&height=1000&seq=receipt-restaurant&orientation=portrait",
      uploadedAt: "2026-08-25T21:15:00",
    },
    createdAt: "2026-08-25T21:20:00",
  },
  {
    id: "exp-005",
    date: "2026-08-24",
    description: "Gasolina",
    categoryId: "cat-transporte",
    amount: 1000,
    paymentMethod: "tarjeta",
    receipt: {
      id: "rec-003",
      fileName: "ticket-gasolinera.jpg",
      fileType: "image",
      fileSize: 102400,
      url: "https://readdy.ai/api/search-image?query=Closeup%20of%20a%20white%20paper%20fuel%20station%20receipt%20with%20printed%20liters%20and%20total%20amount%2C%20on%20a%20clean%20car%20dashboard%2C%20realistic%20document%20photography%2C%20soft%20daylight%2C%20high%20detail&width=800&height=1000&seq=receipt-gas&orientation=portrait",
      uploadedAt: "2026-08-24T16:45:00",
    },
    createdAt: "2026-08-24T16:47:00",
  },
  {
    id: "exp-006",
    date: "2026-08-23",
    description: "Ropa de temporada",
    categoryId: "cat-compras",
    amount: 1250,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-23T17:20:00",
  },
  {
    id: "exp-007",
    date: "2026-08-22",
    description: "Recibo de luz",
    categoryId: "cat-servicios",
    amount: 780,
    paymentMethod: "transferencia",
    createdAt: "2026-08-22T10:00:00",
  },
  {
    id: "exp-008",
    date: "2026-08-20",
    description: "Farmacia del Ahorro",
    categoryId: "cat-salud",
    amount: 340,
    paymentMethod: "efectivo",
    createdAt: "2026-08-20T13:30:00",
  },
  {
    id: "exp-009",
    date: "2026-08-19",
    description: "Cine + palomitas",
    categoryId: "cat-entretenimiento",
    amount: 320,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-19T20:00:00",
  },
  {
    id: "exp-010",
    date: "2026-08-18",
    description: "Curso de inglés online",
    categoryId: "cat-educacion",
    amount: 1200,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-18T11:00:00",
  },
  {
    id: "exp-011",
    date: "2026-08-15",
    description: "Escritorio de oficina",
    categoryId: "cat-hogar",
    amount: 3500,
    paymentMethod: "transferencia",
    notes: "Compra por Amazon",
    createdAt: "2026-08-15T15:00:00",
  },
  {
    id: "exp-012",
    date: "2026-08-14",
    description: "Café con amigos",
    categoryId: "cat-alimentacion",
    amount: 90,
    paymentMethod: "efectivo",
    createdAt: "2026-08-14T10:30:00",
  },
  {
    id: "exp-013",
    date: "2026-08-12",
    description: "Taxi al aeropuerto",
    categoryId: "cat-transporte",
    amount: 150,
    paymentMethod: "efectivo",
    createdAt: "2026-08-12T06:00:00",
  },
  {
    id: "exp-014",
    date: "2026-08-10",
    description: "Membresía gimnasio",
    categoryId: "cat-salud",
    amount: 500,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-10T08:00:00",
  },
  {
    id: "exp-015",
    date: "2026-08-08",
    description: "Internet en casa",
    categoryId: "cat-servicios",
    amount: 599,
    paymentMethod: "tarjeta",
    createdAt: "2026-08-08T09:00:00",
  },
  {
    id: "exp-016",
    date: "2026-07-28",
    description: "Supermercado",
    categoryId: "cat-alimentacion",
    amount: 920,
    paymentMethod: "efectivo",
    createdAt: "2026-07-28T18:00:00",
  },
  {
    id: "exp-017",
    date: "2026-07-25",
    description: "Restaurante italiano",
    categoryId: "cat-alimentacion",
    amount: 480,
    paymentMethod: "tarjeta",
    createdAt: "2026-07-25T20:30:00",
  },
  {
    id: "exp-018",
    date: "2026-07-20",
    description: "Gasolina",
    categoryId: "cat-transporte",
    amount: 950,
    paymentMethod: "tarjeta",
    createdAt: "2026-07-20T15:00:00",
  },
  {
    id: "exp-019",
    date: "2026-07-15",
    description: "Renta del departamento",
    categoryId: "cat-hogar",
    amount: 8000,
    paymentMethod: "transferencia",
    notes: "Pago mensual",
    createdAt: "2026-07-15T09:00:00",
  },
  {
    id: "exp-020",
    date: "2026-07-10",
    description: "Suscripción Spotify",
    categoryId: "cat-entretenimiento",
    amount: 129,
    paymentMethod: "tarjeta",
    createdAt: "2026-07-10T08:00:00",
  },
  {
    id: "exp-021",
    date: "2026-06-30",
    description: "Supermercado",
    categoryId: "cat-alimentacion",
    amount: 810,
    paymentMethod: "efectivo",
    createdAt: "2026-06-30T18:00:00",
  },
  {
    id: "exp-022",
    date: "2026-06-15",
    description: "Renta del departamento",
    categoryId: "cat-hogar",
    amount: 8000,
    paymentMethod: "transferencia",
    createdAt: "2026-06-15T09:00:00",
  },
  {
    id: "exp-023",
    date: "2026-06-05",
    description: "Concierto",
    categoryId: "cat-entretenimiento",
    amount: 1500,
    paymentMethod: "tarjeta",
    createdAt: "2026-06-05T21:00:00",
  },
  {
    id: "exp-024",
    date: "2026-05-20",
    description: "Supermercado",
    categoryId: "cat-alimentacion",
    amount: 780,
    paymentMethod: "efectivo",
    createdAt: "2026-05-20T18:00:00",
  },
  {
    id: "exp-025",
    date: "2026-05-15",
    description: "Renta del departamento",
    categoryId: "cat-hogar",
    amount: 8000,
    paymentMethod: "transferencia",
    createdAt: "2026-05-15T09:00:00",
  },
  {
    id: "exp-026",
    date: "2026-04-12",
    description: "Reparación auto",
    categoryId: "cat-transporte",
    amount: 2800,
    paymentMethod: "tarjeta",
    createdAt: "2026-04-12T14:00:00",
  },
  {
    id: "exp-027",
    date: "2026-04-08",
    description: "Supermercado",
    categoryId: "cat-alimentacion",
    amount: 740,
    paymentMethod: "efectivo",
    createdAt: "2026-04-08T18:00:00",
  },
  {
    id: "exp-028",
    date: "2026-03-18",
    description: "Consulta médica",
    categoryId: "cat-salud",
    amount: 650,
    paymentMethod: "tarjeta",
    createdAt: "2026-03-18T10:00:00",
  },
  {
    id: "exp-029",
    date: "2026-03-05",
    description: "Renta del departamento",
    categoryId: "cat-hogar",
    amount: 8000,
    paymentMethod: "transferencia",
    createdAt: "2026-03-05T09:00:00",
  },
  {
    id: "exp-030",
    date: "2026-02-14",
    description: "Cena de aniversario",
    categoryId: "cat-alimentacion",
    amount: 1850,
    paymentMethod: "tarjeta",
    createdAt: "2026-02-14T20:00:00",
  },
];

export const defaultSettings = {
  userName: "Ana García",
  currency: "MXN",
  monthlyBudget: 12000,
  theme: "light" as const,
  notifications: {
    weeklySummary: true,
    budgetAlert: true,
  },
};